'use client';
import React from 'react';
import { SocialSite } from './NewFooterEntity';
import Image from 'next/image';
import styles from './NewSocialIcon.module.scss';

interface SocialIconProps extends SocialSite {
  isAmp?: boolean;
}

const NewSocialIcon: React.FC<SocialIconProps> = ({ icon, link, name, rel }) => {
  return (
    <a
      aria-label={`Click to check out Benzinga's ${name}`}
      className={`${styles.socialAnchor} ${name}`}
      href={link}
      rel={rel || 'noopener noreferrer'}
      target="_blank"
    >
      <Image alt={name} height={24} priority={false} src={icon} width={24} />
    </a>
  );
};
export default NewSocialIcon;
